import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { IAddCartInstance } from '@base/product/useAddCart';
import ListProductImage from '@base/snippets/ListProduct/ListProductImage';
import IconCheck from '@base/lib/IconCheck';
import Iconfont from '@base/lib/Iconfont';
import AddOnsModal from '@app/product/AddOnsModal';
import styles from './index.module.less';
import useAddOns from '@base/product/useAddOns';
import { useTrans } from 'base/utils/i18n';

type AddOnsProps = {
    addCart: IAddCartInstance;
}

const AddOns: React.FC<AddOnsProps> = ({ addCart }) => {
    const [visible, setVisible] = useState<boolean>(false);
    const addOnsIns = useAddOns({ addCart });
    const { variantAddOns, checkedAddOns, onChangeCheckedAddOns } = addOnsIns;
    const { t } = useTrans();

    const hasChecked = checkedAddOns.length > 0;

    const list = hasChecked
        ? variantAddOns.filter(item => checkedAddOns.includes(item.variantId))
        : variantAddOns;


    return list.length === 0 ? null : (
        <>
            <div
                className={cn(styles.addons, 'flex flex-middle')}
                onClick={() => setVisible(true)}
            >
                <div className={styles.title}>{t('web_product_addons_title')}</div>

                <div className={styles['img-list']}>
                    {list.map(item => (
                        <ListProductImage
                            className={cn(
                                styles.image,
                                { [styles['unchecked']]: !hasChecked },
                                { 'js-add-ons-checked': hasChecked },
                            )}
                            key={item.variantId}
                            product={item}
                            imageSize={40}
                            fixed
                            productTag={hasChecked ? <IconCheck className={styles.check} size={13}/> : false}
                            canJump={false}
                        />
                    ))}
                </div>

                <Iconfont className="icon-arrow-down"/>
            </div>

            <AddOnsModal
                visible={visible}
                onCancel={() => setVisible(false)}
                addOnsIns={addOnsIns}
            />
        </>
    );
};

export default AddOns;
